import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/uni-assets/svgs/house.svg'
import _imports_1 from '@/assets/icons/download-icon.svg'
import _imports_2 from '@/assets/images/empty_escrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-2b5aa34b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "escrow_account"
}
const _hoisted_2 = { class: "escrow_account_top" }
const _hoisted_3 = { class: "escrow_account_header escrow_account_card" }
const _hoisted_4 = { class: "escrow_account_header_top" }
const _hoisted_5 = { class: "escrow_account_property" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "House",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_7 = { class: "escrow_account_emergency_chip" }
const _hoisted_8 = { class: "escrow_account_emergency_chip" }
const _hoisted_9 = { class: "escrow_account_bottom" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "escrow_account_title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Jobs Escrow Account")
], -1))
const _hoisted_11 = { class: "escrow_account_bottom_inner" }
const _hoisted_12 = { class: "escrow_account_bottom_left escrow_account_card" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Your Jobs Escrow Wallet", -1))
const _hoisted_14 = { class: "escrow_account_amount" }
const _hoisted_15 = { class: "escrow_account_amount_title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "escrow_account_amount_label" }, "Available Balance", -1))
const _hoisted_17 = {
  key: 0,
  class: "escrow_account_info_box"
}
const _hoisted_18 = { class: "escrow_account_info_box_text" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "escrow_account_payment_list"
}
const _hoisted_21 = { class: "escrow_account_payment_list_header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Select payment amount", -1))
const _hoisted_23 = { class: "icon-title" }
const _hoisted_24 = { class: "icon-title-info" }
const _hoisted_25 = { class: "escrow_account_payment_list_inner_wrapper" }
const _hoisted_26 = { class: "escrow_account_payment_list_item" }
const _hoisted_27 = { class: "escrow_account_payment_list_item_left" }
const _hoisted_28 = { class: "escrow_account_payment_icon" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "escrow_account_bottom_right" }
const _hoisted_32 = { class: "escrow_account_bottom_right_header" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Your Job Escrow Transactions", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Download",
  width: "12",
  height: "12"
}, null, -1))
const _hoisted_35 = {
  key: 0,
  class: "escrow_account_empty_box"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "escrow_account_empty_box_inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "escrow_account_empty_box_image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "InProgress",
      width: "40",
      height: "52"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "escrow_account_empty_box_text" }, [
    /*#__PURE__*/_createElementVNode("p", null, " Your Job escrow transactions will show up here. Please deposit the required amount into this account to confirm the project. ")
  ])
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "escrow_account_table escrow_account_card" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center"
}, "No transactions", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "text-yellow" }
const _hoisted_44 = { class: "text-green" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Download",
  width: "12",
  height: "12"
}, null, -1))

import TradeType from "@/core/uni-components/TradeType.vue";
import EmergencyChip from "@/core/uni-components/Chips/EmergencyChip.vue";
import StandardChip from "@/core/uni-components/Chips/StandardChip.vue";
import RoutineChip from "@/core/uni-components/Chips/RoutineChip.vue";
import LabelWithValue from "@/core/components/common/LabelWithValue.vue";
import { PROJECT_STORE } from "@/store/modules/project";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { onMounted } from "vue";
import { EscrowStatusEnum, EstimatePhaseType } from "@/core/enums/estimateEnum";
import { ProjectPhaseType, ProjectTypesEnum } from "@/core/enums/ProjectsEnum";
import CurrencyFilter from "@/filters/currency.filter";
import Button from "@/core/components/ui/general/Button.vue";
import EscrowSelectBankModal from "@/modules/project/modal/EscrowSelectBankModal.vue";
import PayDepositModal from "@/modules/project/modal/PayDepositModal.vue";
import PaymentSuccessModal from "@/modules/project/modal/PaymentSuccessModal.vue";
import PaymentFailureModal from "@/modules/project/modal/PaymentFailureModal.vue";
import PayEWalletModal from "@/modules/project/modal/PayEWalletModal.vue";
import tradeEstimateService from "@/core/services/trade-estimate.service";
import { useRoute, useRouter } from "vue-router";
import currencyFilter from "@/filters/currency.filter";
import ToolTip from "@/core/components/common/ToolTip.vue";

const MATERIALS = "Materials";

const SERVICE_CHARGE = 0.03;
const PHASE_FIRST_CHARGE = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'EscrowAccount',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const paymentPayload = ref(null) as any;
const loading = ref(false);
const isOpenEscrowWallet = ref(false);
const isOpenPayDeposit = ref(false);
const isOpenPaymentSuccess = ref(false);
const isOpenPaymentFail = ref(false);
const isOpenPayIntoWallet = ref(false);
const isDisableContinue = ref(false);
const projectEstimateWithEscrow = ref(null);
const transactionsList = ref();
const downloadLoading = ref(false);
const projectDetails = computed(
  () => store.getters[`${PROJECT_STORE}/projectDetails`]
);

const onContinue = () => {
  if (!isDisableContinue.value) {
    isOpenEscrowWallet.value = true;
  }
};
const onCloseEscrowModal = () => {
  isOpenEscrowWallet.value = false;
};
const onConfirmEscrowBank = (payload) => {
  isOpenEscrowWallet.value = false;
  paymentPayload.value = payload;
  isOpenPayDeposit.value = true;
};

const onClosePayDepositModal = () => {
  isOpenPayDeposit.value = false;
  paymentPayload.value = null;
  loading.value = false;
};

const onRedirectEWalletModal = () => {
  isOpenEscrowWallet.value = false;
  isOpenPayIntoWallet.value = true;
  paymentPayload.value = null;
};
const onRedirectBankModal = () => {
  isOpenPayIntoWallet.value = false;
  isOpenEscrowWallet.value = true;
  paymentPayload.value = null;
};
const onConfirmPayDeposit = async () => {
  try {
    loading.value = true;
    localStorage.setItem(
      "escrowPayment",
      JSON.stringify({
        url: route?.params?.refId,
        path: "project-details",
      })
    );
  } catch (error) {
    isOpenPaymentFail.value = false;
    console.log(error);
  } finally {
    isOpenPayDeposit.value = false;
  }
};

const onClosePaymentSuccessModal = async () => {
  isOpenPaymentSuccess.value = false;
};
const onClosePaymentFailureModal = () => {
  isOpenPaymentFail.value = false;
};

const onClosePaymentWalletModal = () => {
  isOpenPayIntoWallet.value = false;
};
const onConfirmPayIntoWallet = () => {
  isOpenPayIntoWallet.value = false;
};

const estimateDetails = computed(
  () => store.getters[`${PROJECT_STORE}/getProjectEstimateDataWithEscrow`]
);
const totalPhaseTasks = computed(
  () =>
    estimateDetails.value.estimationPhase.filter(
      (phase: any) => phase.phaseType === EstimatePhaseType.LABOUR
    ).length
);

const phaseCheckboxes = ref([]) as any;
const escrowBalance = computed(
  () => store.getters[`${PROJECT_STORE}/getProjectEstimateEscrowBalance`]
);
const totalPhaseAmount = (
  phaseType: EstimatePhaseType,
  amount: number,
  vat: number,
  isFirstPhase: boolean
) => {
  let sum = 0;
  let vatSum = amount * vat;
  let phaseCost = amount + vatSum;
  let serviceCost = phaseCost * SERVICE_CHARGE;
  sum += serviceCost + phaseCost;

  if (isFirstPhase) {
    sum += PHASE_FIRST_CHARGE;
  }

  // grantDiscount

  if (
    phaseType === EstimatePhaseType.LABOUR &&
    totalPhaseTasks &&
    estimateDetails.value?.grantAmount
  ) {
    const grantAmount: number = parseFloat(estimateDetails.value?.grantAmount);
    const totalTasks: number = parseFloat(totalPhaseTasks.value);
    const grantDiscountTotal = grantAmount / totalTasks;
    const finalAmount = sum - grantDiscountTotal;
    return Math.floor(finalAmount * 100) / 100;
  }

  return sum;
};

const getPhaseDetails = () => {
  const filterPhase = estimateDetails.value?.estimationPhase?.map(
    (phase: any) => {
      if (
        [EscrowStatusEnum.NOT_STARTED_POKED].includes(
          phase?.escrowStatus?.id
        ) ||
        !phase?.escrowStatus?.id
      ) {
        return {
          ...phase,
          totalAmount: totalPhaseAmount(
            phase?.phaseType,
            phase?.subTotal,
            phase?.vat,
            phase?.isOld
          ),
          class: "not-started",
          icon: "mdi-information-slab-circle-outline mdi",
          src: "clock.svg",
          color: "#80829F",
          box: true,
        };
      } else if (phase?.escrowStatus?.id == EscrowStatusEnum.STAGE_COMPLETE) {
        return {
          ...phase,
          totalAmount: totalPhaseAmount(
            phase?.phaseType,
            phase?.subTotal,
            phase?.vat,
            phase?.isOld
          ),
          class: "complete",
          icon: "mdi-check-circle",
          color: "#40AE42",
          box: false,
        };
      } else if (
        [
          EscrowStatusEnum.IN_PROGRESS_POKED,
          EscrowStatusEnum.IN_PROGRESS,
        ].includes(phase?.escrowStatus?.id)
      ) {
        return {
          ...phase,
          totalAmount: totalPhaseAmount(
            phase?.phaseType,
            phase?.subTotal,
            phase?.vat,
            phase?.isOld
          ),
          class: "in-progress",
          icon: "mdi-check-circle",
          color: "#faa500",
          src: "inprogress.svg",
          box: false,
        };
      } else
        return {
          ...phase,
          totalAmount: totalPhaseAmount(
            phase?.phaseType,
            phase?.subTotal,
            phase?.vat,
            phase?.isOld
          ),
        };
    }
  );
  phaseCheckboxes.value = filterPhase;
};
const getProjectRedirectTabName = computed(
  () => store.getters[`${PROJECT_STORE}/getProjectRedirectTabName`]
);

const getPaymentDetails = async () => {
  if (!route.query.result || !route.query.paymentInitiationId) return;
  if (
    route.query &&
    route.query.result == "success" &&
    route.query.paymentInitiationId
  ) {
    const paymentInitiationId = route.query.paymentInitiationId;
    try {
      const response = await tradeEstimateService.verifyDepositsPayment(
        paymentInitiationId
      );
      if (response.status === "verified") {
        isOpenPaymentSuccess.value = true;
        // await tradeEstimateService.updateProjectEstimatePhaseStatus(
        //   estimateDetails.value?.id,
        //   {
        //     escrowStatusId: EscrowStatusEnum.IN_PROGRESS,
        //   }
        // );

        if (projectDetails.value?.projectEstimateId)
          await store.dispatch(
            `${PROJECT_STORE}/getProjectEstimateWithEscrow`,
            projectDetails.value?.projectEstimateId
          );
      } else {
        isOpenPaymentFail.value = true;
      }
      getPhaseDetails();
    } catch (error) {
      isOpenPaymentFail.value = true;
      console.log(error);
    }
  } else {
    isOpenPaymentFail.value = true;
  }
  router.push({
    path: `/project-details/${projectDetails.value?.refId}`,
  });
  store.dispatch(
    `${PROJECT_STORE}/setProjectRedirectTabName`,
    "escrow-account"
  );
};

const getRelativeDateDescription = (inputDate: any) => {
  const today = new Date();
  const date = new Date(inputDate);

  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - date.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  if (diffDays === 0) {
    return "Today";
  } else if (diffDays === 1) {
    return "Yesterday";
  } else {
    const dayOfWeek = daysOfWeek[date.getDay()];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${dayOfWeek}, ${day} ${month} ${year}`;
  }
};

const phaseEstimateType = (phase: any) => {
  if (phase?.phaseType === ProjectPhaseType.MATERIAL) return MATERIALS;
  else return phase?.name;
};
const formattedCurrency = (value: any) => {
  return CurrencyFilter.formatToCurrency(value);
};
const estimatePhasesMessage = computed(() => {
  if (selectedPhases.value.length === 0) {
    isDisableContinue.value = true;
    return null;
  }
  isDisableContinue.value = false;

  const phaseDetails = selectedPhases.value
    .map((phase: any) => {
      const updatedSubTotal =
        parseFloat(phase?.updatedSubTotal) +
        parseFloat(phase?.updatedSubTotal) * SERVICE_CHARGE;
      return `${
        phase?.phaseType === ProjectPhaseType.LABOUR ? phase.name : MATERIALS
      } ( ${
        parseFloat(phase?.updatedSubTotal) > 0
          ? currencyFilter.formatToCurrency(updatedSubTotal.toString())
          : currencyFilter.formatToCurrency(phase.totalAmount.toFixed(2))
      })`;
    })
    .join(" & ");
  const totalAmount = selectedPhases.value
    .reduce((sum: any, phase: any) => {
      const amount =
        parseFloat(phase?.updatedSubTotal) > 0
          ? parseFloat(phase?.updatedSubTotal) +
            parseFloat(phase?.updatedSubTotal) * SERVICE_CHARGE
          : phase.totalAmount;
      return sum + amount;
    }, 0)
    .toFixed(2);

  return `
    <p><strong>Required Deposit (${currencyFilter.formatToCurrency(
      totalAmount
    )}) </strong>
    </p>
    
    <p>
      Deposits required for
      <strong>${phaseDetails}</strong> to
      kick-off the project.
    </p>
  `;
});

// const selectedPhases = computed(() => {
//   const phases = phaseCheckboxes.value.filter(
//     (phase: any) =>
//       phase.box === true &&
//       [
//         EscrowStatusEnum.NOT_STARTED_POKED,
//         EscrowStatusEnum.NOT_STARTED,
//       ].includes(phase?.escrowStatus?.id)
//   );

//   return phases;
// });
const selectedPhases = computed(() => {
  return phaseCheckboxes.value.filter((phase: any) => {
    if (!phase.box) return false;

    if (
      [
        EscrowStatusEnum.IN_PROGRESS,
        EscrowStatusEnum.IN_PROGRESS_POKED,
      ].includes(phase?.escrowStatus?.id)
    ) {
      return parseFloat(phase?.updatedSubTotal) > 0;
    }

    return [
      EscrowStatusEnum.NOT_STARTED_POKED,
      EscrowStatusEnum.NOT_STARTED,
    ].includes(phase?.escrowStatus?.id);
  });
});

const subTotalAmount = computed(() => {
  const sum = selectedPhases.value.reduce((sum: any, currentValue: any) => {
    const isUpdateChangePhaseAmount =
      [
        EscrowStatusEnum.IN_PROGRESS,
        EscrowStatusEnum.IN_PROGRESS_POKED,
      ].includes(currentValue?.escrowStatus?.id) &&
      parseFloat(currentValue?.updatedSubTotal) > 0;

    let phaseCost = !isUpdateChangePhaseAmount
      ? currentValue?.subTotal
      : parseFloat(currentValue?.updatedSubTotal);
    let serviceCost = phaseCost * SERVICE_CHARGE;

    sum += serviceCost + phaseCost;

    //phase_first_charge
    if (currentValue?.isOld && !parseFloat(currentValue?.updatedSubTotal))
      sum += PHASE_FIRST_CHARGE;
    return sum;
  }, 0);
  return sum;
});

const vatTotal = computed(() => {
  return selectedPhases.value.reduce((accumulator: any, currentValue: any) => {
    return accumulator + currentValue?.vat * currentValue?.subTotal;
  }, 0);
});

const downloadTransactionData = async () => {
  try {
    downloadLoading.value = true;
    const response = await tradeEstimateService.getEscrowTransactionList(
      projectDetails.value?.id
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "downloaded.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.log("error", error);
  } finally {
    downloadLoading.value = false;
  }
};
onMounted(async () => {
  getPhaseDetails();
  await getPaymentDetails();

  try {
    transactionsList.value =
      await tradeEstimateService.getProjectEstimateTransactionList(
        projectDetails?.value?.id
      );
  } catch (error) {
    console.log("error", error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(TradeType, { value: "Commercial" }),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_icon, { class: "escrow_account_property_icon" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(projectDetails.value?.projectProperties?.length) + " Property", 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (projectDetails.value?.type === _unref(ProjectTypesEnum).EMERGENCY)
                    ? (_openBlock(), _createBlock(EmergencyChip, { key: 0 }))
                    : _createCommentVNode("", true),
                  (projectDetails.value?.type === _unref(ProjectTypesEnum).STANDARD)
                    ? (_openBlock(), _createBlock(StandardChip, { key: 1 }))
                    : _createCommentVNode("", true),
                  (projectDetails.value?.type === _unref(ProjectTypesEnum).ROUTINE)
                    ? (_openBlock(), _createBlock(RoutineChip, { key: 2 }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("h2", null, _toDisplayString(projectDetails.value?.name), 1),
            _createVNode(LabelWithValue, {
              class: "!tw-w-[auto]",
              noBg: true,
              justifyStart: true,
              label: "Project ID:",
              data: projectDetails.value?.refId
            }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(formattedCurrency(escrowBalance.value)), 1),
                _hoisted_16
              ]),
              (estimatePhasesMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi mdi-alert-circle",
                      color: "#FFA500"
                    }),
                    _createElementVNode("div", _hoisted_18, [
                      (estimatePhasesMessage.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            innerHTML: estimatePhasesMessage.value
                          }, null, 8, _hoisted_19))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (phaseCheckboxes.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, [
                          _createVNode(ToolTip, { description: "This estimate outlines how the grant money will be distributed\n                for labor and materials. Each phase will incur a 3% service\n                charge on the total amount, and the first phase will also have\n                an additional fee of 5 euros. Depending on your location, VAT\n                may apply as well. Please review all costs carefully before\n                proceeding." })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phaseCheckboxes.value, (phase) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "escrow_account_payment_list_inner",
                          key: phase?.id
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                (
                          ([
                            _unref(EscrowStatusEnum).IN_PROGRESS_POKED,
                            _unref(EscrowStatusEnum).IN_PROGRESS,
                          ].includes(phase?.escrowStatus?.id) &&
                            !parseFloat(phase?.updatedSubTotal)) ||
                          !phase?.escrowStatus?.id
                        )
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: require('@/assets/images/' + phase?.src),
                                      width: "18"
                                    }, null, 8, _hoisted_29))
                                  : (
                          ([
                            _unref(EscrowStatusEnum).IN_PROGRESS_POKED,
                            _unref(EscrowStatusEnum).IN_PROGRESS,
                          ].includes(phase?.escrowStatus?.id) &&
                            parseFloat(phase?.updatedSubTotal) > 0) ||
                          !phase?.escrowStatus?.id
                        )
                                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                        key: 1,
                                        modelValue: phase.box,
                                        "onUpdate:modelValue": ($event: any) => ((phase.box) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : (
                          [_unref(EscrowStatusEnum).NOT_STARTED_POKED].includes(
                            phase?.escrowStatus?.id
                          )
                        )
                                      ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                          key: 2,
                                          modelValue: phase.box,
                                          "onUpdate:modelValue": ($event: any) => ((phase.box) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 3,
                                          icon: phase?.icon,
                                          color: phase?.color
                                        }, null, 8, ["icon", "color"]))
                              ]),
                              _createElementVNode("p", null, [
                                _createTextVNode(_toDisplayString(phaseEstimateType(phase)) + " - ", 1),
                                _createElementVNode("strong", null, _toDisplayString(formattedCurrency(phase?.totalAmount)), 1)
                              ]),
                              (
                        ([
                          _unref(EscrowStatusEnum).IN_PROGRESS_POKED,
                          _unref(EscrowStatusEnum).IN_PROGRESS,
                        ].includes(phase?.escrowStatus?.id) &&
                          parseFloat(phase?.updatedSubTotal) > 0) ||
                        !phase?.escrowStatus?.id
                      )
                                ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(`(${formattedCurrency(
                          parseFloat(phase?.updatedSubTotal) +
                            parseFloat(phase?.updatedSubTotal) * SERVICE_CHARGE
                        )})`), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["escrow_account_payment_list_status", phase?.class])
                            }, [
                              _createElementVNode("p", null, _toDisplayString(phase?.escrowStatus?.name || "Not Started"), 1)
                            ], 2)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createVNode(_component_v_divider, { thickness: 2 }),
                    _createVNode(Button, {
                      class: "button button-orange",
                      label: "continue",
                      onClick: onContinue,
                      disabled: isDisableContinue.value
                    }, null, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_v_btn, {
                  variant: "white",
                  "aria-label": "Download Button",
                  class: "download_btn",
                  onClick: downloadTransactionData,
                  disabled: downloadLoading.value
                }, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    _createTextVNode(" Download PDF")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              (transactionsList.value && transactionsList.value?.data?.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("table", null, [
                  _hoisted_39,
                  _createElementVNode("tbody", null, [
                    (
                    transactionsList.value && transactionsList.value?.data?.length === 0
                  )
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_40, _hoisted_42))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(transactionsList.value?.data, (transaction) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: transaction?.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(getRelativeDateDescription(transaction?.transactionDate)), 1),
                            _createElementVNode("td", null, _toDisplayString(transaction?.description), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", _hoisted_43, _toDisplayString(formattedCurrency(transaction?.transactionAmount)), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", _hoisted_44, _toDisplayString(transaction?.status), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                class: "download_btn",
                                "aria-label": "Download Button"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_45
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        (isOpenEscrowWallet.value)
          ? (_openBlock(), _createBlock(EscrowSelectBankModal, {
              key: 0,
              selectedPhases: selectedPhases.value,
              subTotalAmount: subTotalAmount.value,
              vatTotal: vatTotal.value,
              projectDetails: projectDetails.value,
              estimateDetails: estimateDetails.value,
              onOnClose: onCloseEscrowModal,
              onOnConfirm: onConfirmEscrowBank,
              onOnRedirectEWallet: onRedirectEWalletModal
            }, null, 8, ["selectedPhases", "subTotalAmount", "vatTotal", "projectDetails", "estimateDetails"]))
          : _createCommentVNode("", true),
        (isOpenPayDeposit.value)
          ? (_openBlock(), _createBlock(PayDepositModal, {
              key: 1,
              paymentPayload: paymentPayload.value,
              totalPayAmount: subTotalAmount.value + vatTotal.value,
              onOnClose: onClosePayDepositModal,
              onOnConfirm: onConfirmPayDeposit
            }, null, 8, ["paymentPayload", "totalPayAmount"]))
          : _createCommentVNode("", true),
        (isOpenPaymentSuccess.value)
          ? (_openBlock(), _createBlock(PaymentSuccessModal, {
              key: 2,
              onOnClose: onClosePaymentSuccessModal
            }))
          : _createCommentVNode("", true),
        (isOpenPaymentFail.value)
          ? (_openBlock(), _createBlock(PaymentFailureModal, {
              key: 3,
              onOnClose: onClosePaymentFailureModal
            }))
          : _createCommentVNode("", true),
        (isOpenPayIntoWallet.value)
          ? (_openBlock(), _createBlock(PayEWalletModal, {
              key: 4,
              selectedPhases: selectedPhases.value,
              subTotalAmount: subTotalAmount.value,
              vatTotal: vatTotal.value,
              projectId: projectDetails.value?.id,
              onOnRedirectBank: onRedirectBankModal,
              onOnClose: onClosePaymentWalletModal,
              onOnConfirm: onConfirmPayIntoWallet
            }, null, 8, ["selectedPhases", "subTotalAmount", "vatTotal", "projectId"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})